module.exports = __webpack_public_path__ + "c1fb10906360b74bbc7625db1279a930.jpg";